// extracted by mini-css-extract-plugin
export default {"subheading":"Subheading_subheading__qr2wG","subheading-before":"Subheading_subheading-before__PwsiX","subheading-after":"Subheading_subheading-after__cn92l"};